"use client"

import "../css/profile.css"
import "../css/wa.css"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import { FaPlus, FaCheck } from "react-icons/fa6"
import { useToast } from "../components/ToastProvider"
import SunEditor from "suneditor-react"
import "suneditor/dist/css/suneditor.min.css"
import { publishComment } from "../api/postApi"
import { FaChevronDown, FaRegClock, FaRegHeart, FaRegComment, FaHeart, FaRegCommentAlt, FaCheckCircle } from "react-icons/fa"
import { MdOutlineArrowForwardIos, MdArrowForwardIos } from "react-icons/md"
import { RxDividerVertical } from "react-icons/rx"
import { IoTimeOutline, IoHeart } from "react-icons/io5"

function Profile() {
  const { id } = useParams() // URL에서 id를 가져옴
  const navigate = useNavigate()
  const [profileData, setProfileData] = useState("")
  const [isFollowed, setIsFollowed] = useState(false)
  const [articleData, setArticleData] = useState([])
  const showToast = useToast()

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [pageInputValue, setPageInputValue] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [activeTab, setActiveTab] = useState("posts")
  const [editorData, setEditorData] = useState("")

  const [commentListData, setCommentListData] = useState(null) // 아티클 데이터를 저장할 상태
  const [commentData, setCommentData] = useState(null) // 에러 상태
  const [commentCount, setCommentCount] = useState(0) // 아티클 데이터를 저장할 상태
  const [repl, setRepl] = useState(null) // 에러 상태

  const [sortType, setSortType] = useState("latest") // 기본 최신순
  const [sortedComments, setSortedComments] = useState([])
  const [myId, setMyId] = useState(false) // 열려 있는 답글 박스 ID 저장

  const [openReplyBox, setOpenReplyBox] = useState(null) // 열려 있는 답글 박스 ID 저장

  useEffect(() => {
    const fetchProfileData = async () => {
      setIsLoading(true)
      let token = localStorage.getItem("token")
      if (!token) {
        token = null
      }
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/profile/get`, {
          id,
          token,
          page: currentPage,
        })

        const article = data.article
        setIsFollowed(data.isFollowed)
        setArticleData(article)
        setProfileData(data.result)
        setCommentListData(data.commentData)
        setTotalPages(data.pagination.totalPages)
        setMyId(data.myIdForDelete)

        console.log(data)
        if (data.result.isMe) {
          window.location.href = "/my"
        }
      } catch (error) {
        showToast("프로필 정보를 불러오는 중 오류가 발생했습니다.", { type: "error" })
      } finally {
        setIsLoading(false)
      }
    }

    fetchProfileData()
  }, [id, currentPage])

  useEffect(() => {
    if (!Array.isArray(commentListData)) return // commentListData가 배열인지 확인

    const sorted = [...commentListData].sort((a, b) => {
      if (sortType === "latest") {
        return new Date(b.date) - new Date(a.date)
      } else if (sortType === "popular") {
        return b.like - a.like
      }
    })

    setSortedComments(sorted)
  }, [commentListData, sortType])
  // Function to fetch articles for a specific page
  const fetchArticlesByPage = async (page) => {
    if (page < 1 || page > totalPages) return

    setIsLoading(true)
    let token = localStorage.getItem("token")
    if (!token) {
      token = null
    }

    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/profile/get_articles_by_page`, {
        id,
        token,
        page,
      })

      setArticleData(data.articles)
      setCurrentPage(data.pagination.currentPage)
    } catch (error) {
      showToast("게시글을 불러오는 중 오류가 발생했습니다.", { type: "error" })
    } finally {
      setIsLoading(false)
    }
  }

  const handleReplyToggle = (commentId) => {
    setOpenReplyBox((prevId) => (prevId === commentId ? null : commentId))
  }
  const toggleDelete = async (code, type) => {
    const token = localStorage.getItem("token")
    try {
      // 댓글 좋아요 요청
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/delete`, {
        token: token,
        id: code,
        type: type,
      })
      window.location.reload()
    } catch (error) {
      console.error("Failed to like comment:", error)
    }
  }

  const handleReplChange = (content) => {
    setRepl(content) // state 업데이트
  }

  const handleComment = async () => {
    console.log(commentData)
    try {
      // Check if commentData is empty or undefined
      if (!commentData || commentData.trim() === "" || commentData === "<p><br></p>") {
        alert("다시 한번 시도해주세요.")
        return
      }

      const data = {
        thisId: id,
        content: commentData,
        articleId: id,
        isRepl: false,
      }
      const response = await publishComment(data)
      if (response && response.commentId) {
        const token = localStorage.getItem("token")
        let response
        if (token) {
          response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id, token })
        } else {
          response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id })
        }
        const data = response.data.comment
        const commentCoun = data.length
        setCommentCount(commentCoun)
        setCommentListData(data)
        setCommentData("")
      } else {
        alert("실패했습니다. 다시 시도해주세요.")
      }
    } catch (error) {
      console.error("Publication error:", error)

      // Handle 401 Unauthorized response
      if (error.response && error.response.status === 401) {
        alert("로그인이 필요합니다. 로그인 페이지로 이동합니다.")
        window.location.href = "/login"
      } else {
        alert("오류가 발생했습니다.")
      }
    }
  }

  const handleRepl = async (replId) => {
    try {
      // Check if repl is empty or undefined
      if (!repl || repl.trim() === "" || repl === "<p><br></p>") {
        alert("답글 내용을 입력해주세요.")
        return
      }

      const data = {
        thisId: replId,
        content: repl,
        articleId: id,
        isRepl: true,
      }
      const response = await publishComment(data)
      if (response && response.commentId) {
        setRepl("")
        const token = localStorage.getItem("token")
        let response
        if (token) {
          response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id, token })
        } else {
          response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id })
        }
        const data = response.data.comment
        const commentCoun = data.length
        setCommentCount(commentCoun)
        setCommentListData(data)
      } else {
        alert("실패했습니다. 다시 시도해주세요.")
      }
    } catch (error) {
      console.error("Publication error:", error)

      // Handle 401 Unauthorized response
      if (error.response && error.response.status === 401) {
        alert("로그인이 필요합니다. 로그인 페이지로 이동합니다.")
        window.location.href = "/login"
      } else {
        alert("오류가 발생했습니다.")
      }
    }
  }

  const handleCommentLike = async (targetId) => {
    const token = localStorage.getItem("token")

    try {
      // 댓글 좋아요 요청
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/community/like`,
        {
          id: targetId,
          target: "comment",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      const response2 = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id, token })
      const data = response2.data.comment
      const commentCoun = data.length
      setCommentCount(commentCoun)
      setCommentListData(data)
    } catch (error) {
      console.error("Failed to like comment:", error)

      // 500 오류 발생 시 알림
      if (error.response && error.response.status === 500) {
        alert("로그인 후 반응할 수 있습니다.")
      }
    }
  }

  // Handle page navigation
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  const handleEditorChange = (content) => {
    setEditorData(content)
  }
  // Handle manual page input
  const handlePageInputChange = (e) => {
    setPageInputValue(e.target.value)
  }

  // Handle page input submission
  const handlePageInputSubmit = () => {
    const pageNumber = Number.parseInt(pageInputValue)
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      goToPage(pageNumber)
      setPageInputValue("")
    } else {
      showToast(`페이지 번호는 1에서 ${totalPages} 사이여야 합니다.`, { type: "warn" })
    }
  }

  const handleFollow = async () => {
    try {
      const token = localStorage.getItem("token")
      if (!token) {
        showToast("로그인 후 사용할 수 있는 기능입니다.", { type: "warn" })
      } else {
        const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/profile/follow`, {
          id,
          token,
        })
        setIsFollowed(data.isFollowed)
        if (isFollowed) {
          showToast("구독을 취소했습니다", { type: "info" })
        } else {
          showToast(profileData.username + "님의 글을 구독합니다.", { type: "success" })
        }
      }
    } catch (error) {
      showToast("구독 처리 중 오류가 발생했습니다.", { type: "error" })
    }
  }

  // Generate page numbers for pagination
  const renderPageNumbers = () => {
    const pageNumbers = []
    const maxVisiblePages = 5

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2))
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1)
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <div key={i} className={`wa-page-number ${currentPage === i ? "active" : ""}`} onClick={() => goToPage(i)}>
          {i}
        </div>,
      )
    }

    return pageNumbers
  }

  return (
    <>
      <div className="pf-center">
        <div className="pf-main">
          <div className="wa-card" style={{ marginTop: "15px" }}>
            <div className="pf-flex">
              <div className="pf-img wa-profile">
                <img src={profileData.profile || "/placeholder.svg"} alt="프로필 이미지" />
              </div>
              <div className="pf-name">{profileData.username}</div>
            </div>
            {profileData.email === "deleted@deleted" ? (
              <span>이 프로필은 삭제되었습니다.</span>
            ) : (
              <>
                <div className="pf-desc" style={{ marginTop: 15 }}>
                  {profileData.desc}
                </div>
                <button className="pf-follow" onClick={handleFollow}>
                  {isFollowed ? (
                    <span>
                      <FaCheck />
                      구독 중
                    </span>
                  ) : (
                    <span>
                      <FaPlus />
                      구독하기
                    </span>
                  )}
                </button>
              </>
            )}
            
            {profileData.expert === '1' && 
                <div className="article-l gray">
                    <span className="title"><FaCheckCircle  />익스퍼트로 인증된 유저입니다.</span>
                    <span>익스퍼트란? 전문가로 인증된 유저입니다.</span>

                    
                    <div className='cte-gointo'>
                        <span onClick={() => window.location.href = `/expert`}>자세히 알아보기 <MdArrowForwardIos/></span><RxDividerVertical/>
                        <span onClick={() => window.location.href = `/form?type=expert`}>익스퍼트 신청하기 <MdArrowForwardIos/></span>
                    </div>
                    
                </div>
            }
          </div>
          <div className="pf-selection">
            <div className="wa-option-box" style={{ marginBottom: 10 }}>
              <div
                className={`wa-option ${activeTab === "posts" ? "selected" : ""}`}
                onClick={() => setActiveTab("posts")}
              >
                글
              </div>
              <div
                className={`wa-option ${activeTab === "guestbook" ? "selected" : ""}`}
                onClick={() => setActiveTab("guestbook")}
              >
                방명록
              </div>
            </div>
          </div>

          {activeTab === "posts" && (
            <div className="wa-card" style={{ padding: 10 }}>
              {isLoading ? (
                <div className="loading-indicator">로딩 중...</div>
              ) : articleData.length === 0 ? (
                <div className="no-articles">작성한 글이 없습니다.</div>
              ) : (
                <>
                  {articleData.map((article) => (
                    <div
                      key={article.id}
                      className="pf-at-box"
                      onClick={() => (window.location.href = "/community/article/" + article.id)}
                    >
                      {article.previewImage ? (
                        <div className="cm-card-list-item-thumb wa-thumb">
                          <img src={article.previewImage || "/placeholder.svg"} alt="" />
                        </div>
                      ) : null}
                      <div className="pf-at-main" style={{ marginLeft: 10 }}>
                        <div className="pf-at-title">{article.title}</div>
                        <div className="pf-at-date">{article.date}</div>
                      </div>
                      <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                        <div className="pf-at-ct">
                          <FaRegHeart />
                          {article.like}
                        </div>
                        <div className="pf-at-ct">
                          <FaRegComment />
                          {article.commentCount}
                        </div>
                      </div>
                    </div>
                  ))}

                  {totalPages > 1 && (
                    <div className="wa-page">
                      {currentPage > 1 && (
                        <div className="wa-page-number prev" onClick={() => goToPage(currentPage - 1)}>
                          이전
                        </div>
                      )}

                      {renderPageNumbers()}

                      {currentPage < totalPages && (
                        <div className="wa-page-number next" onClick={() => goToPage(currentPage + 1)}>
                          다음
                        </div>
                      )}

                      <input
                        className="wa-page-number input"
                        type="number"
                        placeholder="이동할 페이지 번호"
                        value={pageInputValue}
                        onChange={handlePageInputChange}
                        min="1"
                        max={totalPages}
                      />
                      <button className="wa-page-number" onClick={handlePageInputSubmit}>
                        이동
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          )}

          {activeTab === "guestbook" && (
            <div className="wa-card pf-note" style={{ padding: 0 }}>
              <SunEditor
                mode="inline"
                onChange={(content) => setCommentData(content)}
                setContents={commentData}
                placeholder={`${profileData.username}님에게 방명록을 남겨보세요`}
                lang="ko"
                setOptions={{
                  maxHeight: "550px",
                  placeholder: "여기에 내용을 입력해주세요...",
                  buttonList: [
                    ["undo", "redo"],
                    ["formatBlock"],
                    ["bold", "italic", "underline", "strike", "fontColor", "hiliteColor"],
                    ["align", "horizontalRule"],
                    ["outdent", "indent"],
                    ["table", "link", "image"],
                  ],
                  font: ["Wanted Sans", "Arial", "Comic Sans MS", "Courier New", "Georgia", "Tahoma", "Verdana"],
                  fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36],
                  defaultStyle: "font-size: 16px; font-family: Arial, sans-serif;",
                }}
              />
              <button className="pf-btn" onClick={handleComment}>
                등록
              </button>
              <hr />

              <div className="at-comment-section" style={{ padding: 15 }}>
                <div className="at-comment-select">
                  <button onClick={() => setSortType("latest")}>최신순</button>
                  <button onClick={() => setSortType("popular")}>인기순</button>
                </div>
                {sortedComments.map((comment) => (
                  <div key={comment.id} className="at-comment-box">
                    {myId === comment.writer.id && (
                      <div className="at-comment-delete" onClick={() => toggleDelete(comment.id, "comment")}>
                        삭제하기
                      </div>
                    )}

                    <div
                      className="at-comment-ct-header"
                      onClick={() => (window.location.href = `/profile/${comment.writer.id}`)}
                    >
                      <div className="at-comment-ct-profile wa-profile">
                        <img src={comment.writer.profile || "/placeholder.svg"}></img>
                      </div>
                      <div className="at-comment-ct-name">{comment.writer.username}
                      {comment.writer.expert === '1' && <FaCheckCircle className='check' />}</div>
                      <div className="at-comment-ct-info" style={{ marginLeft: "5px" }}>
                        <FaRegClock /> {comment.date}
                      </div>
                    </div>

                    <div className="at-comment-ct-content" dangerouslySetInnerHTML={{ __html: comment.content }}></div>

                    <div className="at-comment-ct-info">
                      {comment && comment.likedThis ? (
                        <span onClick={() => handleCommentLike(comment.id)}>
                          <FaHeart style={{ fill: "red" }} /> 좋아요 {comment.like}
                        </span>
                      ) : (
                        <span onClick={() => handleCommentLike(comment.id)}>
                          <FaRegHeart /> 좋아요 {comment.like}
                        </span>
                      )}
                      <div onClick={() => handleReplyToggle(comment.id)} style={{ cursor: "pointer" }}>
                        <FaRegCommentAlt /> 답글 달기
                      </div>
                    </div>

                    {comment.replyCount > 0 && (
                      <div className="at-comment-repl" onClick={() => handleReplyToggle(comment.id)}>
                        <FaChevronDown />
                        답글 {comment.replyCount}개
                      </div>
                    )}

                    <div
                      className="at-comment-repl-box"
                      style={{ display: openReplyBox === comment.id ? "block" : "none", maxWidth: "95%" }}
                    >
                      <div className="at-repl-ct">
                        <SunEditor
                          mode="inline"
                          onChange={handleReplChange}
                          setContents={repl}
                          placeholder="댓글 작성"
                          lang="ko"
                          setOptions={{
                            height: "400px",
                            maxHeight: "550px",
                            placeholder: "여기에 내용을 입력해주세요...",
                            buttonList: [
                              ["undo"],
                              ["formatBlock"],
                              ["bold", "italic", "underline", "strike", "fontColor", "hiliteColor"],
                              ["align", "horizontalRule"],
                              ["table", "link", "image"],
                            ],
                            font: [
                              "Wanted Sans",
                              "Arial",
                              "Comic Sans MS",
                              "Courier New",
                              "Georgia",
                              "Tahoma",
                              "Verdana",
                            ],
                            fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36],
                            defaultStyle: "font-size: 16px; font-family: Arial, sans-serif;",
                          }}
                        />
                        <button
                          className="at-comment-submit"
                          onClick={() => handleRepl(comment.id)}
                          style={{ minWidth: 80 }}
                        >
                          등록
                        </button>
                      </div>
                      {comment.reply.map((repl) => (
                        <div key={repl.id} className="at-comment-box">
                          {myId === repl.writer.id && (
                            <div className="at-comment-delete" onClick={() => toggleDelete(repl.id, "comment")}>
                              삭제하기
                            </div>
                          )}
                          <div
                            className="at-comment-ct-header"
                            onClick={() => (window.location.href = `/profile/${repl.writer.id}`)}
                          >
                            <div className="at-comment-ct-profile wa-profile">
                              <img src={repl.writer.profile || "/placeholder.svg"}></img>
                            </div>
                            <div className="at-comment-ct-name">{repl.writer.username}
                                
                            {repl.writer.expert === '1' && <FaCheckCircle className='check' />}
                            </div>
                            <div className="at-comment-ct-info" style={{ marginLeft: "5px" }}>
                              <FaRegClock /> {repl.date}
                            </div>
                          </div>
                          <div
                            className="at-comment-ct-content"
                            dangerouslySetInnerHTML={{ __html: repl.content }}
                          ></div>

                          <div className="at-comment-ct-info">
                            {repl && repl.likedThis ? (
                              <span onClick={() => handleCommentLike(repl.id)}>
                                <FaHeart style={{ fill: "red" }} /> 좋아요 {repl.like}
                              </span>
                            ) : (
                              <span onClick={() => handleCommentLike(repl.id)}>
                                <FaRegHeart /> 좋아요 {repl.like}
                              </span>
                            )}
                            {/* <div onClick={() => handleReplToRepl(repl.writer.id)} style={{ cursor: 'pointer' }}>
                                                <FaRegCommentAlt /> 답글 달기
                                            </div> */}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default Profile

